<div class="button"
  [style.background-color]="color"
  [style.color]="textColor"
  [style.min-width]="minWidth"
  (click)="eventClick()"
>
  <div class="contenido">
    @if(icon !== ''){
      <mat-icon class="icono">
        {{icon}}
      </mat-icon>
    }
    @if (text !== '') {
      <span class="texto">{{text}}</span>
    }
  </div>
</div>